import { render, staticRenderFns } from "./lifelist.vue?vue&type=template&id=e9b2bee2&scoped=true"
import script from "./lifelist.vue?vue&type=script&lang=js"
export * from "./lifelist.vue?vue&type=script&lang=js"
import style0 from "./lifelist.vue?vue&type=style&index=0&id=e9b2bee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b2bee2",
  null
  
)

export default component.exports